//import BankWithdrawal from "@/views/frontDeskManagement/bankTransaction/BankWithdrawal.vue";

export default {
  about: "Home",
  accomplish: "Accomplish",
  account: "Account",
  accountApplyList: "List of account application",
  accountBusiness: "Business account",
  accountCancellation: "Account cancellation",
  accountDrawMoney: "Account withdrawal",
  accountList: "Account list",
  accountMaintenanceFees: "Account maintenance fees",
  accountRemittanceNotAccount: "Account remittance",
  accountType: "Account type",
  accountAmount: "Account amount",
  activityName: "Activity name",
  add: "Create",
  addExpense: "Add Expense",
  addAccount: "Account creation",
  addBalanceAdjustment: "add BalanceAdjustment",
  addBusiness: "Business creation",
  addConfig: "Configurtion creation",
  addInterBankTransfer: "Add inter-bank transfer",
  addRemunerationRules: "Create remuneration rule",
  addRole: "Create profile",
  addServiceChargeRules: "Create fees rule",
  //addServiceChargeRulesCountries: "Create fees rule between countries",
  addServiceChargeRulesCountries: "Create fees rule between cities",
  address: "Address",
  alerts: "Alerts",
  alertCEMTIF: "Alert CEMTIF",
  alertCenter: "Alert Center",
  all: "All",
  allianceBusiness: "Distributor",
  allianceBusinessJoin: "Distributor account creation",
  allianceBusinessQuit: "Distributor account closing",
  alternatePhone: "Secondary phone",
  amountInvolvedRange: "Amount range",
  amount: "Amount",
  //
  adjustLimit: "Adjust transaction limit",
  antiMoneyLaundering: "Anti-Money Laundering",
  transactionFiltering: "Transaction filtering",
  transactionAlert: "Transaction alert",
  listOfWantedPersons: "List of wanted persons",
  //
  applayRemark: "Application remarks",
  applicationB: "Transaction apply",
  applicationType: "Transaction type",
  apply: "Application",
  applyCode: "Transaction code",
  applyId: "Application number",
  applyInfo: "Application information",
  applyAmountMustBePositive: "Apply amount must be positive",
  areaConfig: "Region creation",
  auditor: "Validator",
  backlog: "Processing",
  balanceAdjustment: "balance Adjustment",
  selectBank: "selectBank",
  bankAccount: "Bank account",
  bankAddress: "Bank Address",
  bankDeposit: "BankDeposit",
  bankingTansaction: "BankingTransaction",
  bankWithdrawal: "BankWithdrawal",
  bankName: "Bank name",
  bankOperationCheck: "bankOperationCheck",
  bankDepositApply: "BankDepositApply",
  basicInfo: "Basic information",
  batchRemittancePayeeNotAccount: "Multiple remittance",
  batchOfRemittanceReversal: "Multiple remittance cancellation",
  batchTransfer: "Multiple transfer",
  beneficiaryAddress: "Beneficiary address",
  beneficiariesAddress: "Beneficiaries address",
  beneficiaryInfo: "Beneficiary information",
  businessConfig: "Transaction configuration",
  businessHandling: "Transaction",
  businessLicense: "Business license",
  businessLicenseCode: "Business license number",
  businessLicenseImage: "Business license photo",
  businessManaged: "Transaction management",
  businessMenu: "Transaction menu",
  businessName: "Transaction name",
  comingSoon: "Coming soon",
  cancel: "Cancel",
  cancellationClientAccount: "Personal account closing",
  cancellationCompanyAccount: "Entreprise account closing",
  cashNotAccount: "Money remittance",
  channelAccountWithdrawalApplicationB: "Withdrawal account application",
  channelCashWithdrawalB: "Cash withdrawal application",
  channelDealerManage: "Distributor management",
  channelInformationInquiry: "Distributor information inquiry",
  channelMerchantAccountRechargeApplicationB: "Account recharge application",
  channelMerchantCashRechargeApplicationB: "Demande de recharge de cash",
  check: "Validation",
  checkBusiness: "Transaction validation",
  checkInterBankTransfer: "Inter-bank transfer validation",
  checkOrg: "Enterprise validation",
  checkPending: "Validation in progress",
  checkResult: "Validation result",
  checkStatus: "Validation status",
  closingManagement: "Closing management",
  branchClosingStatements: "Branch Closing Statements",
  childBusiness: "Sub-transaction",
  city: "City",
  close: "Close",
  closed: "CLOSED",
  code: "Code",
  redeemRemittance: "Redeem remittance",
  comments: "Comments",
  confirm: "Confirm",
  cooperativePartnerJoin: "Partner account opening",
  cooperativePartnerQuit: "Partner account closing",
  country: "Country",
  "Coupon exceeds max allowed": "Coupon exceeds max allowed",
  createdViaMobileApp: "Created via Mobile",
  creationTime: "Creation date",
  customer: "Customer",
  customers_list: "Customers accounts list",
  customersList: "Customers list",
  customerID: "Customer ID",
  customerLogin: "Customer login",
  currentAmountLimit: "Current amount limit",
  dateOfBirth: "Date of birth",
  dateTransaction: "Date of transaction",
  dealType: "Transaction type",
  delete: "Delete",
  department: "Department",
  deposit: "Cash deposit",
  depositAmount: "Deposit amount",
  depositBusiness: "Deposit transaction",
  depositInfo: "Deposit information",
  depositorInfo: "Depositor information",
  detailedAddress: "Address",
  detailedInfo: "Information details",
  directSaleStore: "BNIF branch",
  directStoreAccount: "BNIF branch account",
  distributorMode: "Distributor mode",
  distributorLite: "Distributor lite",
  unbind: "Unbind",
  standard: "Standard",
  distributorModeHint:
    "Agents share the chief's pool with per-agent thresholds",
  viewAgentThresholds: "View agent thresholds",
  agentThresholds: "Agent thresholds",
  viewAgentThreshold: "View threshold",
agentThreshold: "Agent threshold",
netConsumed: "Net consumed",
consumption: "Consumption",
noThresholdConfigured: "No threshold configured",
resetNetConsumed: "Reset consumption",
set: "Set",


  active: "Active",
  blocked: "Blocked",
  download: "Download",
  drawMoneyBusiness: "Withdrawal transaction",
  edit: "Edit",
  editAccount: "Account editing",
  editBusiness: "Transaction editing",
  editConfig: "Configuration editing",
  editInterBankTransfer: "Edit Transfer",
  editRemunerationRules: "Remuneration rule editing",
  editRole: "Profile editing",
  editServiceChargeRules: "Fees rule editing",
  // editServiceChargeRulesCountries: "Fees rule between countries",
  editServiceChargeRulesCountries: "Fees rule between cities",
  employeesAccount: "Employee account",
  endTime: "End time",
  error: "Error",
  escrowAccount: "Escrow account",
  exceptional: "abnormal",
  expenseManagement: "Expense Management",
  expenseList: "expenseList",
  expenseType: "expense Type",
  explain: "Explanation",
  expireDate: "Expire date",
  electronicMoneyOutstanding: "Electronic Money Outstanding",
  advancedCustomerHistory: "Advanced Customer History",
  advancedCustomerTranRecord: "Transactions History",
  batchTransactionHistory: "Batch Transactions History",
  transactionsHistory: "Transactions History",
  myHistory: "My History",
  customerBalance: "Customer Balances",
  orgBalance: "Distributor Balances",
  extend: "Extension",
  externalDeal: "External transaction",
  failing: "Fail",
  familyAddress: "Family address",
  financial: "Financial",
  firstName: "First name",
  fixedPrice: "Fixed amount",
  fixedPriceSettlement: "Settling fixed amount",
  foldMenu: "Fold menu",
  forbidden: "Deactivate",
  franchiseStoreAccount: "Distributor account",
  getApproved: "Validate",
  have: "Yes",
  home: "Home",
  homeCountry: "Country",
  idCard: "ID card",
  idCardBack: "Back of ID card",
  idCardFront: "Front of ID card",
  idNumber: "ID card number",
  idCardType: "ID card type",
  ifThePsswordIsResetSuccessfullyItWillBeTheSameAsTheLoginAccount:
    "If your password is successfully reset, it will be the same for the login account",
  image: "Photo",
  incident: "Incident",
  incidentDate: "Incident date",
  incidentType: "incident Type",
  incomeLevel: "Income level",
  inProgress: "IN PROGRESS",
  individualAccount: "Personal account",
  information: "Information",
  inputInfo: "Enter information",
  inputPhoneOrAccount: "Enter the phone or account number",
  interBankTransfer: "Inter-bank transfer",
  internalDeal: "Internal transaction",
  lastName: "Last name",
  legalPerson: "Legal person",
  legalPersonFirstName: "Legal person first name",
  legalPersonIdCard: "Legal person ID card",
  legalPersonImage: "Legal person photo",
  legalPersonLastname: "Legal person last name",
  level: "Level",
  linkPhone: "Phone number",
  loading: "Loading……",
  loaginAccount: "Login account",
  loaginPassword: "Login password",
  lock: "Lock",
  lockAccount: "Account lock",
  lockApply: "Apply account lock",
  logOutApply: "Account unlock",
  login: "Connection",
  loginAccount: "Login account",
  loginPassword: "Login password",
  mainBusiness: "Main activity",
  maritalStatus: "Marital status",
  maritalStatus0: "Single",
  maritalStatus1: "Married",
  maritalStatus2: "Divorced",
  material: "Material",
  merchantLogin: "Merchant login",
  merchantPayments: "Merchant payments",
  mobileAccountCheck: "Mobile Account Validation",
  monetaryLimitation: "Amount limitation",
  monitoring: "Monitoring",
  name: "Name",
  nation: "Country",
  nationality: "Nationality",

  nextStep: "Next",
  new: "NEW",
  newAmountLimit: "New montant",
  normal: "Normal",
  notApproved: "Not approved",
  notChargeNotConfig: "No charge, no need for configuration",
  notHave: "Without",
  notLoginPassword: "The password size must be between 6 and 18 digits",
  notNull: "Can not be empty",
  note: "Message",
  notification: "Notification",
  notificationManage: "Notification management",
  number: "Number",
  numberCode: "Numeric code",
  object: "Object",
  openClientAccount: "Personal account opening",
  openCompanyAccount: "Enterprise account opening",
  operateSuccessfully: "Transaction succeeded",
  operationFailure: "Transaction failed",
  org: "Organisation",
  orgAddress: "Organisation address",
  orgId: "Organisation number",
  orgInfo: "Organisation information",
  orgInfoCode: "Organisation code",
  orgManaged: "Organisation management",
  orgName: "Organisation name",
  orgType: "Organisation type",
  orgUserList: "Users list",
  other: "Others",
  otherTransactionsReversal: "Other transaction cancellation",
  regionalBalances: "Regional balances",
  regionalAccounts: "regional Accounts",
  parentNode: "Parent",
  partnerAccount: "Partner account",
  partnerInfoRemainingBalance: "Remaining balance information",
  partnersRemainingBalance: "Partners Remaining balance",
  totalAdvancedCustomerBalance: "Total Partner Balance",
  monthlyRemuneration: "This Month's Commission",
  partnerInfo: "Partner information",
  partnerTransfers: "Partner transfer",
  partnerTransferCheck: "Validation Partner transfer",
  partnerApplyCode: "Purchase order reference",
partnerReason: "Purchase order reason",
  password: "Password",
  payApplicationCheckB: "Recharge validation",
  payeePayment: "Pay by beneficiary",
  payment: "Payment method",
  phone: "Telephone",
  photograph: "Photo",
  placeOfBirth: "Place of birth",
  platform: "Platform",
  platformAccount: "Platform account",
  platformFee: "Platform fees",
  platformFeeAmount: "Platform fees amount",
  platformFeeProportion: "Platform fees purcentage",
  please: "Please",
  pleaseSelectRemunerationTule: "Please select remuneration rule",
  pleaseSelectServiceChargeTule: "Please select transaction fee rule",
  pleaseUploadPictures: "Please upload photo",
  plus: "Add",
  post: "Title",
  prevStep: "Previous",
  proportion: "Purcentage",
  proportionSettlement: "Purcentage settlement",
  proportionSettlementAmount: "Amount of purcentage settlement",
  province: "Region",
  provincial: "Region wide",
  query: "Search",
  invalidLongitude: "Longitude must be between -180 and 180",
  invalidLatitude: "Latitude must be between -90 and 90",
  localisation: "Localisation",
  notSet: "Not set",
  agent: "Agent",
  selectAgent: "Select agent",
  myself: "Myself",
  totalCommissionAmount: "Global commission amount",
  remunerationType: "Cash-in type",
  saveLocalisation: "Save location",
  queryAccountInfo: "Search account information",
  queryChannelRewardADaySum: "Total branch commission (Daily)",
  queryChannelRewardAMonthSum: "Total branch commission (Monthly)",
  queryChannelRewardDetails: "Branch commission details",
  queryDeal: "Transaction search",
  queryDepositB: "Deposit transaction serch",
  queryPlatformRewardADaySum: "Total platform commission (Daily)",
  queryPlatformRewardAMonthSum: "Total platform commission (Monthly)",
  queryPlatformRewardDetails: "Platform commission details",
  queryReward: "Commission search",
  queryTransferB: "Transfer transaction search",
  queryWithdrawalsB: "Withdrawal transaction search",
  reason: "Reason",
  refresh: "Refresh",
  region: "Region",
  registerApply: "Account opening application",
  registerCheck: "Account opening validation",
  registerTime: "Opening date",
  remark: "Remarks",
  remainingBalancePartners: "Remaining balance to partners",
  remainingBalancePartnersCheck: "Validation remaining balance",
  remittance: "Remittance",
  remittanceAmount: "Remittance amount",
  remittanceBusiness: "Remittance transaction",
  remittanceInfo: "Remittance information",
  remittanceRemittance: "Remittance number",
  remittanceSum: "Total od remittance",
  remittancesDrawMoney: "Remittance withdrawal",
  remittancesReversal: "Account remittance cancellation",
  remitterInfo: "Sender information",
  remitterPayment: "Pay by sender",
  remove: "Cancel",
  remuneration: "Commission",
  remunerationManaged: "Commission management",
  remunerationRules: "Commission rule",
  remunerationConfig: "Commission Config",
  remunerationRulesConfig: "Remuneration rule",
  //remunerationRules: "Remuneration rules",
  requiredFields: "Mandatory fields",
  resetLoginPassword: "Reset login password",
  resetPasswords: "Reset password",
  resourceMenu: "Resources menu",
  reversalBusiness: "Cancelling transaction",
  riskProfile: "Risk Profil",
  role: "Profile",
  roleManage: "Profile management",
  rolePermissionSet: "Profile autorisation",
  routeName: "Route name",
  searchable: "Can be searched",
  serviceCharge: "Transaction fees",
  serviceChargeManaged: "Transaction fees management",
  serviceFeeRules: "Transaction fee rule",
  setAuthority: "Autorisation configuration",
  settlementAmount: "Transaction amount",
  settlementRules: "Transaction rule",
  orgLimitManaged: "Transaction limit",
  currentLimit: "Current limit",
  currentDepositLimit: "Current limit",
  monthlyDepositLimit: "Monthly limit",
  customerDepositLimitManaged: "Customer deposit limit",
  sex: "Sex",
  sex0: "Female",
  sex1: "Male",
  slipReference: "Slip reference",
  shortName: "Short name",
  sourceFee: "Distributor name",
  sourceFeeAmount: "Distributor commission amount",
  sourceFeeProportion: "Distributor commission purcentage",
  speciesName: "Name",
  status: "Status",
  startTime: "Start time",
  subminCheckResult: "Submit validation result",
  submit: "Submit",
  success: "Success",
  sum: "Number",
  systemConfig: "System configuration",
  systemSet: "System setting",
  template: "Model",
  time: "Time",
  today: "Today",
  total: "Total",
  totalRemittance: "Total remittance",
  towardsLeft: "To left",
  towardsRight: "To right",
  selectAssistant: "Select employee",
  applyOrgUserId: "Employee ID",
  tradingBetweenCountry: "tradingBetweenCountry",
  transactionsPPE: "Transactions PPE",
  transferAccount: "Account transfer",
  transferBusiness: "Transfer transaction",
  transferInfo: "Transfer information",
  transferReversal: "Transfer cancelling",
  transferorInfo: "Sender information",
  transfersOverrunCheckB: "Transfer over limit validation",
  transaction_password: "Transaction password",
  "Enter your transaction password": "Enter your transaction password",
  invalidTransactionPassword: "Invalid transaction password",
  type: "Type",
  transaction: "Transaction",
  uniekeId: "Unique identification code",
  unlock: "Unlock",
  unlockAccount: "Unlock account",
  update: "Update",
  updateInformation: "Distributor information update",
  upload: "Upload",
  uploadImage: "Upload photo",
  urban: "City",
  available: "Available",
  advancedCusRemittanceList: "Remittances list",
  used: "Used",
  user: "User",
  userLogin: "User login",
  userName: "Username",
  verificationCode: "Verification code",
  wanted: "Wanted",
  warning: "Warning",
  whetherToResetThe: "Resetting",
  withdrawDepositCheckB: "Cash recharge validation",
  withdrawalAmount: "Withdrawal amount",
  withdrawalInfo: "Withdrawal information",
  withdrawalsOverrunCheckB: "Cash withdrawal over limit validation",
  withdrawerAddress: "Customer address",
  withdrawerInfo: "Customer information",
  withdrawalOrg: "Withdrawal agency",
  withdarwMoneyCode: "Remittance code",
  withdrawalCode: "Withdrawal Code",
  withdrawalCodePlaceholder: "Enter withdrawal code",
  useCode: "Use code",
  useIdCard: "Use ID card",
  netAmountToSend: "Net amount to send",
  toBeWithdraw: "Amount to withdraw",
  sendToSelf: "Send to myself",
  //Expense
  OperationalExpenses: "Operational Expenses",
  PersonnelExpenses: "Personnel Expenses",
  BankingandFinancialTransactionExpenses:
    "Banking and Financial Transaction Expenses",
  MarketingandBusinessDevelopment: "Marketing and Business Development",
  OtherExpenses: "Other Expenses",
  expenseOperationCheck: "expenseOperationCheck",

  sanctioned_countries_list: "List sanctioned countries",
  listSanctionedCountries: "Sanctioned countries",
  sanctioned: "Sanctioned",
  pleaseSelect: "Please Select",
  countryCode: "Country code",

  //
  destinationType: "Destination Type",
  organization: "Organization",

  escrowAccountPlaceholder: "Funds will be sent to escrow account",
  pleaseSelectDestination: "Please select destination type",
  sendToEscrow: "Send to Escrow Account",
  //
  low: "Low",
  medium: "Medium",
  high: "High",

  //

  // interBankTransfer: "Inter-bank transfer",
  fromBank: "From bank",
  toBank: "To bank",
  transferCode: "Transfer code",
  referenceNumber: "Reference number",
  transferDate: "Transfer date",
  transferAmount: "Transfer amount",
  transferFees: "Transfer fees",
  transferStatus: "Transfer status",
  Pending: "Pending",
  Completed: "Completed",
  Cancelled: "Cancelled",

  //

  // Alert Dashboard
  criticalAlerts: "Critical",
  warningAlerts: "Warnings",
  infoAlerts: "Information",
  totalUnresolved: "Total Unresolved",
  alertsByType: "Alerts by Type",
  recentAlerts: "Recent Alerts",
  unread: "Unread",
  markRead: "Mark as Read",
  resolve: "Resolve",
  resolved: "Resolved",
  resolveAlert: "Resolve Alert",
  resolutionNote: "Resolution Note",
  enterResolutionNote: "Enter resolution note...",
  markedAsRead: "Marked as read",
  alertResolved: "Alert resolved successfully",
  alertCheckCompleted: "Alert check completed",
  viewAllAlerts: "View All Alerts",
  checkNow: "Check Now",
  alertSettings: "Alert Settings",
  noAlertsFound: "No alerts found",

  depositorFirstName: "Nom du déposant",
  depositorLastName: "Prénom du déposant",
  depositorPhoneNo: "Téléphone du déposant",
  position: "Position",
  "use excel to create": "Import via Excel",
  "download template": "Download template",

  systemError: "System error, please try again",
  httpError: "HTTP Error",
  serverUnreachable: "Server unreachable, check your connection",

  // Alert Types
  lowBankBalance: "Low Bank Balance",
  lowAgencyBalance: "Low Agency Balance",
  lowCardBalance: "Low Card Balance",
  lowCashBalance: "Low Cash Balance",
  pendingFundsHigh: "High Pending Funds",
  unresolvedIncident: "Unresolved Incident",
  largeTransaction: "Large Transaction",
  failedTransactionRate: "High Failure Rate",
  pendingCashLending: "Pending Cash Lending",

  // Severity
  critical: "Critical",
  //warning: "Warning",
  //information: "Information",
  severity: "Severity",
  alertTitle: "Alert Title",
  actions: "Actions",
  // Common
  entity: "Entity",
  currentValue: "Current Value",
  threshold: "Threshold",
  createdAt: "Created At",

  confirmCancelLending: "Are you sure you want to cancel this lending record?",
  operationCancelled: "Operation cancelled",

  updateTime: "Update Time",
  adminReply: "Admin Reply",

cancelBatch: "Cancel request",
reverseBatch: "Cancel & refund",
cancelBatchConfirm: "Permanently cancel this request?",
reverseBatchConfirm: "Cancel this batch and refund the sender? This action cannot be undone.",
reverseBatchWarning: "This will refund the sender and cancel all unclaimed remittances. It cannot be undone.",
beneficiaries: "Beneficiaries",
applyUser: "Applicant",
cancelled: "Cancelled",

"400001:at least one beneficiary already withdrew, reverse transactions one by one":
  "A beneficiary has already withdrawn — reverse transactions one by one",
"400001:nothing to reverse": "No transaction to reverse",
"400001:no batch lines found": "No batch lines found",
"200005:already processed, contact the platform":
  "Request already processed, contact the platform",
"200005:only approved batches can be reversed":
  "Only approved batches can be reversed",
"200005:only company accounts can cancel": "Only company accounts can cancel",

reverseExpense: "Reverse expense",
reverseExpenseConfirm: "Reverse this expense and refund the cash account?",
reverseExpenseWarning: "The amount will be credited back to the branch cash account. This cannot be undone.",
reversed: "Reversed",

cashAdjustment: "Cash adjustment",
orgCashAdjustment: "Branch cash adjustment",
cashGrant: "Cash grant",
orgCashRecharge: "Cash replenishment",
"Loan amount to account": "Loan received",
"Loan amount deduction": "Loan granted",
"Expense amount deduction": "Expense payout",
accountLending: "Electronic money lending",
addRemunerationToCash: "Remuneration payout",
  //
};
